// @flow

import './GetGenericQuotePage.scss';

import React from 'react';

import Banner from '../../components/Banner/Banner';
import { defaultTravelPromoCode } from '../../constants/home';
import { withPrefix } from '../../helpers';
import { ApplyTravelPromoEvent, usePub } from '../../utils/pubSub';

type Props = {
  className: string
};

const SideBanner = ({ className }: Props) => {
  const pubPromo = usePub();
  const withClass = withPrefix('c-GetGenericQuote-sideBanner');

  return (
    <div className={className}>
      <Banner>
        <div>
          <p>
            Click the promocode{' '}
            <span
              className={withClass('__selectText')}
              onClick={() => pubPromo(ApplyTravelPromoEvent, defaultTravelPromoCode)}
            >
              <strong>{defaultTravelPromoCode}</strong>
            </span>{' '}
            to get a <strong>10% discount</strong> on your Multi-Trip Travel Insurance
            Policy exclusively online.
          </p>
        </div>
      </Banner>
    </div>
  );
};

export default SideBanner;
